<template>
  <div class="content">

    <div class="page-header " :class="{'header-hidden': !isScrollTop}">
      <div class="flex px-4 md:block">
        <div class="w-64 lg:w-60 px-4 lg:pl-0 pt-6 md:hidden lg:flex-none">
          <img :src="require('../../assets/images/home-round-ups.png')" width="200"/>
        </div>

        <div class="mt-6 lg:mt-4 md:w-full">
          <div class="font-semibold text-3xl md:text-xl">Round-Ups</div>
          <p class="md:hidden">A donor's round-up change is accumulated and then donated on the last day of the
            month</p>
          <div v-if="roundupsState === 'ready'" class="flex justify-between mt-6 lg:mt-3">
            <div class="text-center">
              <span class="font-black text-4xl md:text-xl">{{ Object.keys(roundupsDonors).length }}</span>
              <div class="md:text-sm mt-2">Total Donors</div>
            </div>

            <div class="text-center px-3">
              <span class="font-black text-4xl md:text-xl">${{ totalPending / 100 | formatMoney }}</span>
              <div class="md:text-sm mt-2">Round-Ups this Month</div>
            </div>

            <div class="text-center px-3">
              <span class="font-black text-4xl md:text-xl">${{ totalMinimum | formatMoney }}</span>
              <div class="md:text-sm mt-2">Monthly Minimum</div>
            </div>

            <div class="text-center">
              <span class="font-black text-4xl md:text-xl">${{ totalCap | formatMoney }}</span>
              <div class="md:text-sm mt-2">Monthly Max Cap</div>
            </div>

          </div>
        </div>

      </div>

    </div>

    <reports-menu
        :start-date="startDate"
        :end-date="endDate"
        :show-date-piker="false"
        v-on:download="download"
        :isSearchBox="true"
        v-model="donorFilter"
    ></reports-menu>

    <div class="flex flex-wrap overflow-hidden px-8 md:px-4 pt-4 d-reports tab-donations">
      <div class="w-4/5 xl:w-4/6 md:w-full pr-5 md:pr-0 d-round-ups mb-5">
        <div class="donations-summary">
          <div class="d-block shadow-md rounded-md bg-white">
            <div class="row title title-with-search">
              <div class="col-sm-6">
                <h2>Round-Ups</h2>
              </div>
              <div class="col-sm-6 text-right">
                <span style="color: white;font-size: 14px;line-height: 24px;">{{null | dateFormat("MMMM YYYY")}}</span>
              </div>
            </div>

            <div class="donated-total">
              <div class="item item-pending">
                <to-coins class="txt-blue" :value="totalPending"></to-coins>
                in Round-Ups
              </div>
              <div class="item"><i>Round-Ups minimum this month will be <b>${{totalMinimum | formatMoney}}</b></i></div>
              <div class="item"><b>${{totalCap | formatMoney}}</b></div>
            </div>
            <div class="clearfix"></div>
            <div class="progress progress-round">
              <div class="progress-val2" v-bind:style="{ width: (totalMinimum/totalCap*100)+'%'}"></div>
              <div class="progress-val" v-bind:style="{ width: (totalPending/totalCap)+'%'}"></div>
            </div>

            <div class="table-nav-wrap">
              <table class="table">
                <tr>
                  <th style="width: 34%">Donor Name & Card</th>
                  <th style="width: 24%">Round-Up Activity this Month</th>
                  <th class="txt-right param-column">Round-Ups/Cap</th>
                  <th class="txt-right param-column">Start Date</th>
                  <th class="txt-right param-column">Ends in .00</th>
                  <th class="txt-right param-column" style="width: 40px"></th>
                  <th style="width: 30px"></th>
                </tr>
              </table>
            </div>
            <div class="user-progress-wrap"
                 :class="{'user-progress-wrap-extend': !isScrollTop}"
            >
              <table class="table" v-if="roundupsState === 'ready'">
                <tr v-for="account in accountsItems"
                    :key="account.id"
                    :class="{'no-border': account.type === 'additional' && !account.is_first}"
                    v-if="account.type === 'one'
                      || (account.type === 'summary' && showAllAccounts.indexOf(account.user.id)===-1)
                      || (account.type === 'additional' && showAllAccounts.indexOf(account.user.id)!==-1)"
                >
                  <td style="width: 34%">
                    <div v-if="account.type !== 'additional' || account.is_first"
                         class="avatar show-donor-info"
                         v-on:click.prevent="showDonorBlock(account.user.id)"
                    >
                      <img v-if="account.donor && account.user.profilePhoto" :src="account.user.profilePhoto"
                           :alt="`${account.user.firstName} ${account.user.lastName}`">
                      <span v-else>{{{fname: account.user.firstName, lname: account.user.lastName} | shortName}}</span>
                    </div>

                    <div class="donor">
                      <span class="show-donor-info"
                            v-on:click.prevent="showDonorBlock(account.user.id)"
                      >{{account.user.firstName}} {{account.user.lastName}}</span>
                      <div class="info"
                           v-on:click.prevent="showMore(account.user.id)"
                           v-if="account.type==='summary'">
                        <a v-on:click.prevent="showMore(account.user.id)"
                           href="#">{{account.accounts_count}} Cards</a> - Click for more
                      </div>
                      <div class="info" v-else>
                        {{account.fundingSource.brand}} **** {{account.fundingSource.last4}}
                      </div>
                    </div>
                  </td>
                  <td style="width: 24%" class="c-prog-wrap">
                    <div class="c-prog">
                      <div class="key">
                        <span v-if="account.type !== 'summary' && account.error"
                              class="txt-blue error-tooltip"
                              :data-error="JSON.stringify(account.error)"
                        ><font-awesome-icon :icon="['fas', 'exclamation-circle']"/> Round-Ups Error</span>
                        <span v-else-if="account.type === 'summary' && account.errors.length" class="txt-blue">
                          <font-awesome-icon :icon="['fas', 'exclamation-circle']"/> {{account.errors.length}} Round-Ups Errors
                        </span>
                        <span v-else>
                          <to-coins class="txt-blue"
                                    :skip-zero-coins="true"
                                    :value="(account.pending.roundupCents)"></to-coins> in Round-Ups
                        </span>

                      </div>
                      <div class="val">${{account.maxCap | formatMoney}}</div>

                    </div>
                    <div class="progress">
                      <div class="value"
                           v-bind:style="{ width: (account.minimumAmount / account.maxCap)*100 + '%'}"
                      ></div>
                      <div class="value value2"
                           v-bind:style="{ width: (account.pending.roundupCents/account.maxCap)+'%'}"
                      ></div>
                    </div>
                  </td>
                  <!--                  <pre>{{account}}</pre>-->
                  <td class="txt-right param-column ">
                    <to-coins
                        :class="{
                          'txt-blue': !(account.type !== 'summary' && account.error),
                          'txt-blue': (account.type !== 'summary' && account.error)
                        }"
                        :value="(account.pending.roundupCents)"></to-coins>
                    / <span class="total">${{account.maxCap | formatMoney}}</span>
                  </td>
                  <td class="txt-right param-column swipes">
                    {{account.createdAt  | dateFormat('MMM DD, YYYY')}}
                  </td>
                  <td class="txt-right param-column multiplier">
                    <span v-if="account.type!=='summary'">${{account.rounding / 100 | formatMoney(2)}}</span>
                  </td>
                  <td class="txt-right param-column" style="width: 40px">
                    <el-dropdown v-if="account.type!=='summary'"
                                 trigger="click"
                                 @command="handleCommand"
                    >
                    <span class="el-dropdown-link inline-block text-gray-500 text-xl
                    rounded-full h-8 w-8 flex items-center justify-center hover:bg-gray-200">
                      <font-awesome-icon :icon="['far', 'ellipsis-v']"/>
                    </span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item :command="['edit', account]">Edit Round-Ups</el-dropdown-item>
                        <el-dropdown-item :command="['cancel', account]">Cancel Round-Ups</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </td>
                  <td style="width: 30px"></td>
                </tr>
              </table>
              <div v-if="roundupsState === 'ready' && accountsItems.length<1" class="empty-placeholder">
                <img :src="require('../../assets/paceholders/62.svg')" alt="No results">
                <h3>No Round-Up Donors Yet</h3>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div class="w-1/5 xl:w-2/6 md:w-full">
        <div class="d-block shadow-md summary summary-primary summary-sticky">
          <div class="summary-header px-6 py-4">
            <h2>Round-Ups</h2>
            <div class="welcome">This Month  |  {{null | dateFormat("MMMM")}}</div>
            <div class="total"><i class="just-wrap">
              <to-coins :value="totalPending"></to-coins>
            </i></div>
          </div>
          <div class="px-6 py-4">
            <div class="welcome">Round-Up Breakdown</div>
            <table class="table">
              <tbody>
              <tr class="txt-blue">
                <td>Total Active Donors</td>
                <td class="value">{{Object.keys(roundupsDonors).length}}</td>
              </tr>
              <tr class="txt-grey">
                <td>Monthly Minimum</td>
                <td class="value">${{totalMinimum | formatMoney}}</td>
              </tr>
              <tr>
                <td>Total Monthly Cap</td>
                <td class="value">${{totalCap | formatMoney}}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="tabs">

      <div class="tab active d-reports d-round-ups clearfix">

      </div><!--round-ups end-->
    </div>

    <donor-info v-if="showDonorInfo"
                :donor-id="showDonorId"
                v-on:close-info="showDonorInfo = false"
    ></donor-info>

    <modal v-if="cancelModal"
           v-on:close-modal="cancelModal = false;"
           :modal-name="'message-turn-off'">
      <div slot="header">
        <div class="info">Cancel Round-Ups</div>
      </div>
      <div slot="body" class="desc">

        <h3 style="margin: 0;">{{selectedDonation.user.firstName}} {{selectedDonation.user.lastName}} -
          {{selectedDonation.fundingSource.brand}} {{selectedDonation.fundingSource.last4}}</h3>
        Are you sure you want to cancel Round-Ups?
        <br><br>
        <em>They'll no longer donate their Round-Up change on this card</em>
      </div>
      <template slot="footer">
        <div>
          <a class="cancel"
             v-on:click.prevent="cancelModal = false"
             href="#">Don't Cancel</a>
        </div>
        <div>
          <button type="submit"
                  v-on:click.prevent="cancelRoundups(selectedDonation);cancelModal = false;"
                  class="btn btn-sm btn-add-to-message btn-delete"
          >Cancel Round-Ups
          </button>
        </div>
      </template>
    </modal>

    <modal v-if="editModal"
           v-on:close-modal="editModal = false;"
           class="list-modal-wrap"
           :modal-name="'message-turn-off'">

      <div slot="header">
        <div class="info">Edit Round-Ups</div>
      </div>
      <div slot="body" class="desc">
        <div class="input-control form-item">
          <label>Full Name</label>
          <div class="name"><b>{{selectedDonation.user.firstName}} {{selectedDonation.user.lastName}}</b></div>
        </div>

        <div class="input-control form-item">
          <label>Round-Up Card</label>
          <div class="name"><b>{{selectedDonation.fundingSource.brand}}
            {{selectedDonation.fundingSource.last4}}</b></div>
        </div>

        <div v-if="allCampaigns && allCampaigns.length>0" class="input-control">
          <label for="d-method">Campaign</label>
          <select
              id="d-method"
              class="form-control"
              v-model="editParams.campaign_id"
          >
            <option :value="null">Area of Greatest Need</option>
            <option v-for="campaign in allCampaigns"
                    :key="campaign.id"
                    :value="campaign.id">{{campaign.name}}</option>
          </select>
        </div>

      </div>
      <template slot="footer">
        <div>
          <a v-on:click.prevent="editModal = false"
             href="#" class="cancel">Cancel</a>
        </div>
        <div>
          <button type="submit"
                  v-on:click.prevent="editRoundUps(selectedDonation);editModal = false;"
                  class="btn btn-sm btn-add-to-message"
          >Save Changes
          </button>
        </div>
      </template>
    </modal>


  </div>
</template>

<script>
  import {saveCSV, formatMoney} from '@/utils/utils';
  import ReportsMenu from './menu.vue';
  import ToCoins from '../Parts/ToCoins.vue';
  import DonorInfo from '../Parts/DonorInfo.vue';
  import reportsMixin from './reports-mixin';
  import reportsMenuMixin from './reports-menu-mixin';
  import scrollInfoMixin from '../../mixins/scroll-info-mixin';
  import Modal from '../Modal/index.vue';
  import Tooltip from 'tooltip.js';
  import store from "@/store";
  import {mapState} from "vuex";

  const moment = require('moment');

  export default {
    name: 'Reports',
    mixins: [reportsMixin, reportsMenuMixin, scrollInfoMixin],
    components: {
      ReportsMenu,
      ToCoins,
      DonorInfo,
      Modal,
    },
    metaInfo: {
      title: 'Reports - Round-Ups',
    },
    mounted() {
      this.initScrollInfo(['.user-progress-wrap', '.content']);
      this.updateRoundups();

      window.addEventListener('resize', this.syncTables);
    },
    methods: {
      handleCommand([command, payload]) {
        switch (command) {
          case 'edit':
            this.selectedDonation = payload;
            this.editParams.campaign_id = payload.campaignId;
            this.editParams.rounding = payload.rounding;
            this.editParams.max_cap = payload.maxCap;
            this.editModal = true
            break
          case 'cancel':
            this.selectedDonation = payload;
            this.cancelModal = true
            break
        }
      },
      editRoundUps(donationInfo) {
        this.$store.dispatch('roundUps/editDonation', {
          charityId: this.activeCharityId,
          accountId: donationInfo.id,
          accountType: donationInfo.accountType,
          params: this.editParams
        })
            .then(() => this.$message('Round-Ups updated'))
            .catch(err => alert(err));
      },
      cancelRoundups(donationInfo){
        this.$store.dispatch('roundUps/cancelDonation', {
          charityId: this.activeCharityId,
          accountType: donationInfo.accountType,
          accountId: donationInfo.id,
        })
            .then(() => this.$message('Round-Ups canceled'))
            .catch(err => alert(err));
      },
      showDonorBlock(donorId) {
        this.showDonorInfo = false;
        this.showDonorId = false;

        this.$nextTick(() => {
          this.showDonorInfo = true;
          this.showDonorId = donorId;
        });
      },
      showMore(user_id) {
        this.showAllAccounts.push(user_id);
        this.initErrorTooltips();
      },
      download(type) {
        let currentMonth = moment().format('MMMM');

        const title = `Round-Ups Report - ${currentMonth}`;
        const header = ['Name', 'Email', 'Card', 'Round-Ups', 'Monthly Cap', 'Start Date', 'Ends in .00',];

        const exportData = this.roundups.map(account => {
          const dt = moment(account.createdAt);

          return [
            `${account.user.firstName} ${account.user.lastName}`,
            account.user.email,
            `${account.fundingSource.brand} **** ${account.fundingSource.last4}`,
            '$' + formatMoney(account.pending.roundupCents / 100, 2, 3),
            '$' + formatMoney(parseFloat(account.maxCap), 2, 3),
            dt.format('MMM D, YYYY'),
            `$${(account.rounding / 100).toFixed(2)}`,
          ];
        });

        if (type === 'pdf') {
// eslint-disable-next-line
          let doc = new jsPDF('landscape');
          doc.text(title, 15, 20);
          doc.autoTable(
            header,
            exportData, {
              margin: {top: 25},
            });
          doc.save(`${title}.pdf`);
        }
        else {
          saveCSV(
            [
              [title],
              header,
              ...exportData
            ],
            {
              filename: `${title}.csv`,
              addHeader: false,
            },
          );
        }
      },
      updatePage() {},
      updateRoundups() {
        this.$store.dispatch('campaigns/updateCampaigns', {charityId: store.state.auth.activeCharityId, force: true});
        this.$store.dispatch('roundUps/fetchAllDonations', {charityId: store.state.auth.activeCharityId});
      },
      syncTables() {
        setTimeout(() => {
          if (document.querySelector('.user-progress-wrap table') &&
            document.querySelector('.user-progress-wrap table').offsetWidth > 200) {
             document.querySelector('.table-nav-wrap table').style.width = document.querySelector(
              '.user-progress-wrap table').offsetWidth + 'px';
          }
        }, 100);
      },
      initErrorTooltips() {
        setTimeout(() => {
          [...document.querySelectorAll('.error-tooltip')].map(obj => {
            const error = JSON.parse(obj.getAttribute('data-error'));

            if (error) {
              new Tooltip(obj, {
                // title: `Date: ${ moment(error.date_received).format('MMM D, YYYY')} <p>${error.reason}</p>`,
                title: `<strong>Round-Up Connection Error</strong>
<p>The Round-Ups connection with the banking institution for this debit/credit card is currently having an issue.</p>`,
                html: true,
              });
            }
          });

        }, 100);
      },
    },
    computed: {
      ...mapState({
        roundupsState: state => state.roundUps.donationsState,
        roundups: state => state.roundUps.donations,
        allCampaigns: state => state.campaigns.allCampaigns,
        activeCharityId: state => state.auth.activeCharityId,
      }),
      roundupsWithMin() {
        const startDay = moment("2021-04-09");

        return this.roundups.map(r => ({
          ...r,
          minimumAmount: moment(r.createdAt) < startDay ? 0 : 9.99
        }));
      },
      totalMinimum() {
        return this.roundupsWithMin.reduce((res, account) => res + parseFloat(account.minimumAmount), 0);
      },
      totalCap() {
        return this.roundupsWithMin.reduce((res, account) => res + parseFloat(account.maxCap), 0);
      },
      totalSwipes() {
        return this.roundupsWithMin.reduce((res, account) => res + parseFloat(account.swipes), 0);
      },
      totalPending() {
        return this.roundupsWithMin.reduce((res, account) => res + parseFloat(account.pending.roundupCents), 0);
      },
      accountsItems() {

        //summary|only one|additional
        let result = [];
        for (let user_id in this.roundupsDonors) {
          if (this.roundupsDonors[user_id].accounts.length === 1) {
            //only one

            let firstAccount = JSON.parse(JSON.stringify(this.roundupsDonors[user_id].accounts[0]));

            firstAccount['accountType'] = firstAccount.type;
            firstAccount['type'] = 'one';
            result.push(firstAccount);
          }
          else {

            let summary = null;
            this.roundupsDonors[user_id].accounts.map(account => {
              if (summary === null) {
                summary = JSON.parse(JSON.stringify(account));
                summary['pending']['roundupCents'] = parseFloat(summary['pending']['roundupCents'])
                summary['accounts_count'] = 1;
                summary['errors'] = [];
                summary['type'] = 'summary';
              }
              else {
                summary['roundupCents'] += parseFloat(account['pending']['roundupCents']);
                summary['pending']['roundupCents'] += parseFloat(account['pending']['roundupCents']);
                summary['swipes'] += parseFloat(account['swipes']);
                summary['minimumAmount'] += parseFloat(account['minimumAmount']);
                summary['maxCap'] += parseFloat(account['maxCap']);
                summary['accounts_count']++;
              }
              if (account.error) {
                summary['errors'].push(account.error);
              }

            });
            result.push(summary);

            let isFirst = true;
            this.roundupsDonors[user_id].accounts.map(account => {
              const addAccount = JSON.parse(JSON.stringify(account));
              addAccount['accountType'] = addAccount.type;
              addAccount['type'] = 'additional';
              addAccount['is_first'] = isFirst;
              result.push(addAccount);
              isFirst = false;
            });
          }
        }

        if (this.donorFilter !== '') {
          const re = new RegExp(this.donorFilter, 'ig');

          result = result.filter(v => `${v.user.firstName} ${v.user.lastName}`.search(re) !== -1);

        }

        result = [...result].sort((i1, i2) => `${i1.user.firstName} ${i1.user.lastName}`
            .localeCompare(`${i2.user.firstName} ${i2.user.lastName}`));

        return result.map((v, i) => ({
          ...v,
          lastIndex: result.length - i,
          startIndex: i,
        }));
      },
      roundupsDonors() {
        if (this.roundupsState !== 'ready') {
          return [];
        }

        const donors = {};

        for (let i = 0; i < this.roundupsWithMin.length; i++) {

          let user_id = this.roundupsWithMin[i].user.id;

          if (!(user_id in donors)) {
            const donorInfo = JSON.parse(JSON.stringify(this.roundupsWithMin[i].user));
            donorInfo['accounts'] = [];
            donors[user_id] = donorInfo;
          }

          donors[user_id]['accounts'].push(JSON.parse(JSON.stringify(this.roundupsWithMin[i])));
        }

        return donors;
      },
    },
    watch: {
      'activeCharityId'() {
        this.updateRoundups();
      },
      'roundups'(){
        this.syncTables();
        this.initErrorTooltips();
      }
    },
    data() {
      return {
        donorFilter: '',
        showAllAccounts: [],
        showDonorInfo: false,
        showDonorId: null,

        cancelModal: false,
        editModal: false,

        selectedDonation: null,
        editParams: {
          campaign_id: null,
          max_cap: null,
          rounding: null,
        },
      };
    },
  };

</script>
<style lang="sass" scoped>
  .content
    .page-header
      .page-header-content
        margin-left: 260px
      .page-header-img
        width: 260px
        padding-top: 20px
    .d-reports
      height: auto
      .user-progress-wrap
        min-height: 0
        @media (min-height: 699px)
          height: calc(100vh - 515px)
          transition: all .5s ease-in-out
        &.user-progress-wrap-extend
          @media (min-height: 699px)
            height: calc(100vh - 330px)

    .search
      margin-right: 0
      &:after
        width: 40px
        height: 30px
      .input-sm
        border: none
        padding: 6px 12px
    .title-with-search
      margin: -22px -30px 0
      background-image: none
      background-color: #0d70e3
      padding: 10px 15px
      .current-month
        color: #ffffff
        opacity: 0.8
      h2
        color: #ffffff
        margin-bottom: 0
        font-size: 20px
</style>
